import { ApiService, toModel } from '~/shared/api'
import { API_PREFIX } from '~/shared/const/request-services'
import { LandingModel } from '~/models/landings'

export class LandingsMainService extends ApiService {
  readonly urls = {
    bySlug: (slug: string) => `${API_PREFIX}/landings/${slug}`,
  }

  getBySlug(slug: string): Promise<LandingModel> {
    return this.http.request({ url: this.urls.bySlug(slug) }).then(toModel(LandingModel))
  }
}
